import {SYSTEM_EVENTS} from '../../events/events';
import BaseService from '../../base/base_service';
import MessageComponent from '../../components/message/message_component';
import {CGP_ERROR_CODES} from '../../exceptions/cgp_error_codes';
import IMessageManagerService, { IMessageOptions } from './message_manager_service_interface';

class MessageManagerService extends BaseService implements IMessageManagerService {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'MessageManagerService';


    /**
     *
     * @param params
     */
    init(params) {
        super.init(params);
        this._subscribeEvents();
    }



    /**
     * @param {MessageModel} msgOptions - an instant of a message to add to the list
     * @throws {Error} title must be define if not throw 'must contain text in message';
     */
    openMessage(msgOptions: IMessageOptions): Promise<MessageComponent> {
        return this._messageUiDecorator(msgOptions);
    }

    showGeneralErrorMessage(): Promise<MessageComponent> {
        return this.openMessage({
            text: this.serviceFactory.regulationService().getErrorMessage(CGP_ERROR_CODES.GENERAL_ERROR),
            type: 'error',
            closeButton: false,
            hasDefaultButton: false,
            buttons: [
                {
                    name: this.serviceFactory.languageService().translation('mdp_ok'),
                    isClosable: true
                }
            ]
        });
    }

    /**
     * Decorator the message to ui
     *
     * @param {MessageModel} msgOptions - the message that need to be Decode
     * @returns {Promise} - promise that resolve when the alert is close
     * @private
     */

    _messageUiDecorator(msgOptions): Promise<MessageComponent> {
        this.logger.info('message : ' + msgOptions.text + ' start convert to ui');
        const messagePromise = new Promise<MessageComponent>((resolve) => {
            const cgpMessage = MessageComponent.create(msgOptions) as MessageComponent;
            cgpMessage.show();
            resolve(cgpMessage);
            this.logger.info('message : ' + msgOptions.text + ' end convert to ui');
        });

        return messagePromise;
    }

    /**
     * Load the Events
     *
     * @private
     */

    _subscribeEvents() {
        this.onSystemEvent(SYSTEM_EVENTS.MESSAGE_OPEN, this.openMessage);
    }
}

export default MessageManagerService;